import * as actionTypes from './types';
import axios from 'axios';
import { store } from '../store';
export const purge = () => ({
  type: actionTypes.PURGE,
});

export const getSession = () => async (dispatch) => {
  try {
    const sessionRes = await axios.get('/api/session');
    const { username } = sessionRes.data;
    dispatch(storeUsername(username));
  } catch (err) {
    console.log(err);
  }
};

export const storeUsername = (username) => ({
  type: actionTypes.STORE_USERNAME,
  username: username,
});

export const setStepId = (stepId) => async (dispatch) => {
  const { stepIdMax, journeyId } = store.getState().app;
  dispatch(setStepIdStore(stepId));
  // If the current stepId is greater than the max step reached
  // Update the step and the journey navigation_stage
  if (stepId > stepIdMax) {
    dispatch(setStepIdMax(stepId));
    await axios.patch(`/api/journey/${journeyId}`, {
      navigation_stage: stepId,
    });
  }
};

export const setStepIdStore = (stepId) => ({
  type: actionTypes.SET_STEPID,
  stepId: stepId,
});

export const setStepIdMax = (stepId) => ({
  type: actionTypes.SET_MAX_STEP,
  stepId: stepId,
});

export const setMilestoneCount = (milestoneCount) => ({
  type: actionTypes.SET_MILESTONE_COUNT,
  milestoneCount: milestoneCount,
});

export const searchOpps = (searchTerm) => async (dispatch) => {
  if (searchTerm.length < 2) {
    console.log('Search term less than 2 characters: ', searchTerm);
    dispatch(setOppLoading(false));
    dispatch(setOpps([]));
    return;
  }
  try {
    dispatch(setOppLoading(true));

    const oppRes = await axios.post('/api/opportunity', {
      q: searchTerm,
    });

    const results = oppRes.data.searchRecords || [];
    dispatch(setOppLoading(false));
    dispatch(setOpps(results));
  } catch (error) {
    dispatch(setOppLoading(false));
    dispatch(setOpps([]));
    console.log('Search Opps Error: ', error);
  }
};

export const setOpps = (opps) => ({
  type: actionTypes.SET_OPPORTUNITIES,
  opps: opps,
});

export const setOppLoading = (isLoading) => ({
  type: actionTypes.SET_OPP_LOADING,
  isLoading: isLoading,
});

export const addToast = (toast) => ({
  type: actionTypes.ADD_TOAST,
  toast: {
    ...toast,
    id: new Date().getTime(),
  },
});

export const removeToast = (toastId) => ({
  type: actionTypes.REMOVE_TOAST,
  id: toastId,
});

export const setCountdown = (countdown) => ({
  type: actionTypes.SET_COUNTDOWN,
  countdown: countdown,
});
